import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center">
            用户评价
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            听听观众们怎么说
          </p>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
            {commentsData.map((item) => (
              <div
                key={item.id}
                className="p-5 rounded-xl bg-background-50 border border-background-200/70"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  &ldquo;{item.text}&rdquo;
                </p>
                <div className="mt-4 flex items-center gap-3">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-10 h-10 rounded-full object-cover"
                    loading="lazy"
                    width="40"
                    height="40"
                  />
                  <div>
                    <div className="text-sm font-semibold text-foreground-800">{item.name}</div>
                    <div className="text-xs text-foreground-400">{item.date}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}